import { Typography } from "@mui/material";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import { Button, Col, Row } from "reactstrap";
import "../styles/auth.css";

export type ModalComponentProps = {
    OnClickLeft: () => void;
    OnClickRight: () => void;
    text: string;
    IsOpen: boolean;
    title: string;
    buttonLeft: string;
    buttonRight: string;
};

export default function ModalComponent(props: ModalComponentProps) {
    return (
        <div>
            <Dialog open={props.IsOpen}>
                <DialogTitle>
                    <Typography variant="h6">{props.title}</Typography>
                </DialogTitle>
                <DialogContent>
                    <DialogContentText style={{ color: "black" }}>{props.text}</DialogContentText>
                </DialogContent>
                <DialogActions className="loginbuttons" style={{ justifyContent: "space-between" }}>
                    <Col md={6} sm={6} xs={6} lg={6} style={{ padding: "0px 0px 0px 14px" }}>
                        <Button onClick={props.OnClickLeft} className="enteraccount" style={{ width: "97%", borderRadius: "5px" }}>
                            {props.buttonLeft}
                        </Button>
                    </Col>
                    <Col md={6} sm={6} xs={6} lg={6} style={{ padding: "0px 14px 0px 0px" }}>
                        <Button onClick={props.OnClickRight} className="enteraccount" style={{ width: "97%", borderRadius: "5px" }}>
                            {props.buttonRight}
                        </Button>
                    </Col>
                </DialogActions>
            </Dialog>
        </div>
    );
}
